import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface CustomShippingSecondParameter extends ApiParameter {
    receiverContactPhone?: string;
}

export interface CustomShippingSecondModel {
    receiverContactPhone?: string;
}

type HandlerType = CustomApiHandler<CustomShippingSecondParameter, CustomShippingSecondModel>;

export const DispatShippingReciverContactPhone: HandlerType = (props: any) => {
    props.dispatch({
        type: "ShippingPage/CustomFields/receiverContactPhone",
        result: props.parameter.receiverContactPhone,
    });
};

export const chain = [DispatShippingReciverContactPhone];

const customShippingFieldReceiverPhone = createHandlerChainRunnerOptionalParameter(
    chain,
    {},
    "CustomShippingFieldReceiverPhone",
);
export default customShippingFieldReceiverPhone;
